import { LeaguesCore } from '../../../../core/collections';
import { CompModel } from '../../models';

export class Comps extends LeaguesCore {
	get model() {
		return CompModel;
	}

	get default_offset() {
		return 10;
	}

	constructor( args ) {
		super( args );
		this.prefix = 'comps/';
		this.count_leagues = 0;
	}

	/**
	 * Method to get user leagues
	 * @param {object} data
	 * @returns {Promise.<Object>|*}
	 */
	show_my( data = {} ) {
		this.url = 'show_my_stats_comps';

		return this.fetch( { data } ).then( response => {
			let count_leagues = response.result.length;
			this.trigger('get:response:leagues:count', count_leagues);
		} );
	}

	/**
	 * Method to get joined leagues
	 * @returns {Comps}
	 */
	showToJoin() {
		this.url = 'show_comps_to_join';
		return this;
	}

}

export default Comps;